import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonComponent } from '../../skeleton/skeleton';

@Component({
  selector: 'nr-text-info-skeleton',
  imports: [SkeletonComponent],
  templateUrl: './text-info-skeleton.html',
  styleUrl: './text-info-skeleton.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextInfoSkeletonComponent {}
